import validator from "../validators/validator";
import Content from "../components/ManageServiceContent";
import { IWizardStep } from "../../../wizard/types";

export const createConfig: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Add service",
  },
  content: Content,
  validator: validator,
};
